import React, { useContext } from 'react';
import {
  ApiFilterOperation,
  FormAutocomplete,
  FormLocalDateField,
  FormSelect,
  useAutocompleteSource,
  useStaticListSource,
} from '@eas/common-web';
import { useEsFiles } from '@modules/es-file/es-file-api';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';
import { autocompleteLabelMapper } from '@components/form/misc/label-mappers';
import { User } from '@models';
import { EsFileState, EvidenceApiUrl } from '@enums';

const relatedFileStates = [
  EsFileState.NEW,
  EsFileState.REGISTER_NEW,
  EsFileState.INDEX,
  EsFileState.JUDGE_OFFICE,
  EsFileState.REGISTER,
  EsFileState.REGISTRY,
];

export function useLoanFields() {
  return function Fields() {
    const { loanStates } = useContext(StaticDataContext);
    const loanedFiles = useEsFiles({
      filters: [
        {
          field: 'agenda.id',
          operation: ApiFilterOperation.EQ,
          value: 'COURT',
        },
        {
          field: 'state.id',
          operation: ApiFilterOperation.EQ,
          value: EsFileState.CLOSED,
        },
      ],
    });
    const relatedFiles = useEsFiles({
      filters: [
        {
          field: 'agenda.id',
          operation: ApiFilterOperation.EQ,
          value: 'COURT',
        },
        {
          field: 'state.id',
          operation: ApiFilterOperation.IN,
          values: relatedFileStates,
        },
      ],
    });
    const borrowers = useAutocompleteSource<User>({
      url: `${EvidenceApiUrl.USERS}/autocomplete`,
      params: {
        filters: [
          { field: 'active', operation: ApiFilterOperation.EQ, value: true },
        ],
      },
    });
    const states = useStaticListSource(loanStates);

    return (
      <>
        <FormAutocomplete
          name="loanedFile"
          label="Zapůjčený spis"
          source={loanedFiles}
          labelMapper={autocompleteLabelMapper}
          required
        />
        <FormAutocomplete
          name="borrower"
          label="Zapůjčeno komu"
          source={borrowers}
          labelMapper={autocompleteLabelMapper}
          required
        />
        <FormAutocomplete
          name="relatedFile"
          label="Ke spisové značce"
          source={relatedFiles}
          labelMapper={autocompleteLabelMapper}
        />
        <FormLocalDateField name="loanedOn" label="Zapůjčeno dne" disabled />
        <FormAutocomplete
          name="loanedBy"
          label="Zapůjčil"
          source={borrowers}
          labelMapper={autocompleteLabelMapper}
          disabled
        />
        <FormSelect
          name="state"
          label="Stav"
          source={states}
          disabled
          valueIsId
        />
        <FormLocalDateField name="returnedOn" label="Vráceno dne" disabled />
      </>
    );
  };
}
